/**
 * Models
 */
export const ProductionPerformanceParameter = (
	json: IProductionMachinePerformanceParameter,
): IProductionMachinePerformanceParameterModel => {
	const { id, name, description, is_active, product_type_id, value, unit, created_at, updated_at } = json

	return {
		id,
		name,
		description,
		value,
		unit,
		isActive: is_active,
		productTypeId: product_type_id ?? null,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ProductionAdditionalParameter = (
	json: IProductionMachineAdditionalParameter,
): IProductionMachineAdditionalParameterModel => {
	const { id, name, value, unit, production_machine_id, product_type_id, created_at, updated_at } = json

	return {
		id,
		name,
		value,
		unit,
		productionMachineId: production_machine_id,
		productTypeId: product_type_id ?? null,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ProductionQualityControlParameter = (
	json: IProductionMachineQualityControlParameter,
): IProductionMachineQualityControlParameterModel => {
	const { id, name, production_machine_id, product_type_id, created_at, updated_at } = json

	return {
		id,
		name,
		productionMachineId: production_machine_id,
		productTypeId: product_type_id ?? null,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ProductionCapacityParameter = (
	json: IProductionMachineCapacityParameter,
): IProductionMachineCapacityParameterModel => {
	const { id, name, unit, value, production_machine_id, product_type_id, created_at, updated_at } = json

	return {
		id,
		name,
		unit,
		value,
		productionMachineId: production_machine_id,
		productTypeId: product_type_id ?? null,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * Forms
 */
export const ProductionPerformanceParametersToForm = (
	model: IProductionMachinePerformanceParameterModel,
): IProductionMachineParameterForm => {
	const { id, name, value, unit } = model

	return {
		id,
		name,
		value,
		unit,
	}
}

export const ProductionAdditionalParametersToForm = (
	model: IProductionMachineAdditionalParameterModel,
): IProductionMachineParameterForm => {
	const { id, name, value, unit } = model

	return {
		id,
		name,
		value,
		unit,
	}
}

export const ProductionQualityControlParametersToForm = (
	model: IProductionMachineQualityControlParameterModel,
): IProductionMachineQualityControlParameterForm => {
	const { id, name } = model

	return {
		id,
		name,
	}
}

/**
 * Payloads
 */
export const ProductionPerformanceParameterToPayload = (
	productTypeId: number | null,
	model: IProductionMachineParameterForm,
): IProductionMachinePerformanceParameterPayload => {
	const { id, value } = model

	return {
		product_type_id: productTypeId,
		parameter_id: id,
		value,
	}
}

export const ProductionAdditionalParameterToPayload = (
	productTypeId: number | null,
	model: IProductionMachineParameterForm,
): IProductionMachineAdditionalParameterPayload => {
	const { name, value, unit } = model

	return {
		product_type_id: productTypeId,
		name,
		value,
		unit,
	}
}

export const ProductionQualityControlParameterToPayload = (
	productTypeId: number | null,
	model: IProductionMachineParameterForm,
): IProductionMachineQualityControlParameterPayload => {
	const { name } = model

	return {
		product_type_id: productTypeId,
		name,
	}
}

export const ProductionCapacityParameterToPayload = (
	productTypeId: number | null,
	model: IProductionMachineParameterForm,
): IProductionMachineCapacityParameterPayload => {
	const { name, value, unit } = model

	return {
		product_type_id: productTypeId,
		name,
		value,
		unit,
	}
}
